export enum ExtendDOCSubscriptionExtensionsFormFields {
  ChangeSubscriptionPackageModel = 'changeSubscriptionPackageModel',
}
